import { done, error } from './common';

export function saveLicense(applicantId, license, callback) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.post(`/api/v2/applicants/${applicantId}/licenses`,
      {
        body: license
      })
      .then(resp => resp.data)
      .then(done(callback))
      .catch(error(callback))
    ;
  };
}

export function deleteLicense(applicantId, clientId, callback) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.del(`/api/v2/applicants/${applicantId}/licenses/${clientId}`)
      .then(resp => resp.data)
      .then(done(callback))
      .catch(error(callback))
    ;
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/v2/applicants/licenses.js